/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SelectItemsStoreFacade } from "@well/select-items-state";

@Pipe({
  name: 'translateSelectItem',
})
export class TranslateSelectItemPipe implements PipeTransform {

  private selectItemsStoreFacade = inject(SelectItemsStoreFacade);
  private translateService = inject(TranslateService);

  transform(value: any): any {
    if (!value) {
      return value;
    }

    const item = this.selectItemsStoreFacade.getSignalItemByKey(this.translateService.currentLang, value);
    return item()?.defaultLabel ?? value;
  }

}
